const quickShareItems = [
  "quickShareDisableNotificationPopup", //Quick share:disable result popup
  "quickShareSendEmail", //Quick Share Send Email By Default
  "quickShareFullAccess", //Quick Share Set Full Access By Default
  "quickShareAttachThumbnail", //Quick Share Attach Thumbnail By Default
  "quickShareOpenEmailClient", //Quick Share open in email client after share
];

const normalShareItems = [
  "shareyyyymmdd", //Use yyyy/MM/dd for Share
  "shareddmmyyyy", //Use dd/MM/yyyy for Share
  "EXPIREDAYS", //Share Expiration Days
  "EXPIREDAYSMAX", //Maximum Share Expiration Days
  "EMAILFROM", //Share Email From
  "EMAILTO", //Share Email To
  "EMAILCC", //Share Email CC
  "EMAILBCC", //Share Email BCC
  "EMAILREPLYTO", //Share Email Reply To
  "EMAILSUBJECT", //Share Email Subject
  "SENDEMAILDEFAULT", //Share Send Email By Default
  "EMAILBODY", //Share Email Body
  "shareEmailBodyNoHTMLArea", //Share Email Body - Disable HTML editor
  "SHAREMETHOD", //Default Share to User (Internal/External)
  "shareThumbnail", //Share Window:Default to Attach Thumbnails
  "shareFiles", //Share Window:Default to Attach Files
  "defaultShareMethod", //Share Window:Default Share Type (Copy, Reference, Move)
  "defaultShareMethodCrushDrop", //Share Window:Default Share Type (Copy, Reference, Move) - only for CrushDrop
  "shareAdvanced", //Share Window:Default to Share Advanced
  "shareAllowUploads", //Share Window:Default Share to Allow Full Access
  "shareAllowUploadsPrivs", //Share Window:Default Share Permissions on full access
  "shareAllowPrivsModification", //Share Window:Allow to modify permissions
  "hideShareMethod", // Share Window:Hide Share Method
  "hideInternalShareMethod", // Share Window:Hide Internal Share Option
  "hideExternalShareMethod", // Share Window:Hide External Share Option
  "hideShareType", // Share Window:Hide Share Type
  "hideShareSendEmail", // Share Window:Hide Send Email
  "hideShareExpiresRow", // Share Window:Hide Share Expires Input
  "hideShareLoginsRow", // Share Window:Hide Share Maximum Number Of Uses Input
  "ShareDefaultLoginsValue", // Share Window:Default Maximum Number Of Uses (-1 = Unlimited, 1,2,3..etc.. up to 20 number of uses)
  "hideShareFromRow", // Share Window:Hide Share From Input
  "hideShareToRow", // Share Window:Hide Share To Input
  "hideShareCCRow", // Share Window:Hide Share CC Input
  "hideShareBCCRow", // Share Window:Hide Share BCC Input
  "hideShareReplyToRow", // Share Window:Hide Share Reply To Input
  "hideShareSubjectRow", // Share Window:Hide Share Email Subject Input
  "readonlyShareSubject", // Share Window:Make Share Email Subject Read only
  "hideShareBodyRow", // Share Window:Hide Share Email Body Input
  "readonlyShareBody", // Share Window:Make Share Email Body Read only
  "hideAdvancedOption", // Share Window:Hide Share Advanced Option
  "hideAttachThumbnailOption", // Share Window:Hide Attach Thumbnail Option
  "hideAttachFilesOption", // Share Window:Hide Attach Files Option
  "hideFullAccessOption", // Share Window:Hide Full Access Option (When Advanced Selected)
  "hideUserPassGenerationOption", // Share Window:Hide Generate User/Pass
  "hideUserGenerationOption", // Share Window: Hide Generate Username
  "hidePassGenerationOption", // Share Window: Hide Generate Password
  "shareWindowNoUserInfoAfterShare", // Share Window:Dont show username and password info after share
  "hideShareResultLink", // Share Window:Dont show share link after share
  "shareWindowNoOpenInEmail", // Share Window:Dont show \Open in Email Client\ after share
  "shareWindowNoOpenInNewTab", // Share Window:Dont show \Open in a separate window\ link
  "customShareLinkURL", // Share Window:Use this URL to generate share link
  "shareWindowEnableUsernameLookup", // Share Window:Enable Username lookup while sharing files internally
  "shareWindowDefaultPermissions", // Share Window:Default permissions while sharing files internally (values can be:upload, download and delete. Comma separated)
  "shareWindowHidePermissions", // Share Window:Hide permissions selection while sharing files internally
  "shareWindowEnableMultipleUsernameSelection", // Share Window:Enable multiple user selection by default (Applies only when internal user lookup is enabled)
  "shareWindowDisableDirectLinkForFile", // Share Window:Hide direct link option while sharing single file
  "shareWindowFlagDirectLinkForFile", // Share Window: Select Direct link sharing for single file
  "shareWindowHideDownloadButtonVisible", // Share Window:Show option to hide download button
  "shareWindowHideDownloadButtonVisibleDefaultVal", // Share Window:Hide download button option selected by default
  "hideShareComments", // Share Window:Hide Share Comments
  "showShareKeywords", // Share Window:Show Share Keywords
  "shareIncludeAllRecursiveItemsList", // Share Window:Insert all selected items in email body (including folder contents)
  "forceGeneratePasswordShare", //Share Window:Force to use generated password in share
  "shareDisableNotificationPopup", //Share Window:disable result popup
  "shareShowCopyEmailBody", //Share Window:Show copy email body to clipboard in the result popup
  "shareHideCopyLinkButton", //Share Window:Don't show copy link button in share result popup
  "discourageEmailsInInternalShares", //Share Window:Warn if email address used in internal share
  "hideShareMultipleSelectionQuick", //Share Window: Don't show Select multiple users quickly option for internal shares
  "shareWindowFooterInstructions", //Share Window: Footer instructions/notes
  "shareWindowResultDisableSMTPError", //Share Window: Don't show SMTP error message even when email sending fails
  "altTempAccount", //Share: Show alternate TempAccount
  "defaultAltTempAccount", //Share: Default alternate TempAccount
  "splitShareRequests", //Share: Share separately for each email targets
  "normalShareOpenEmailClient", //Normal Share open in email client after share
  "basket_HideShare", //Basket:Hide Share button
  "groupShareFiles", //Group share files in unique folders
  "groupShareFilesCrushDrop", //Group share files in unique folders - only for CrushDrop"
  "dontClosePopupOnClip", //Keep share result window open on copy link to clipboard actio
];

const getSharingCustomizations = (type = "normal", data = {}) => {
  const customizations = type === "normal" ? normalShareItems : quickShareItems;
  const result = {};
  if (data && Object.keys(data).length > 0) {
    Object.keys(data).forEach(function (_key) {
      const item = data[_key];
      let { key, value } = item;
      if (customizations.indexOf(key) >= 0) {
        if (value === "true" || value === "false") {
          value = value === "true" ? true : false;
        }
        if (key === "EMAILBODY") {
          const curValue = value.replace(/\\r/g, "\r").replace(/\\n/g, "\n");
          const emailVal = curValue;
          const curVal = emailVal;
          const nameBodySeparator = "``````";
          const templateSeparator = "^^^^^^";
          const _templates = curVal || "";
          const templates = _templates.split(templateSeparator);
          let defaultTemplate;

          for (let i = 0; i < templates.length; i++) {
            const splits = templates[i].split(nameBodySeparator);
            const [name = "Default", body] = splits;
            const isDefault = name.endsWith("_default");
            if (isDefault) defaultTemplate = body;
          }
          result.defaultEmailBody =
            defaultTemplate ||
            "A user would like to share a file with you. This link will expire on {date} at {time}.\n\n{web_link}";
        }
        if (key === "SHAREMETHOD") {
          key = "shareMethod";
          value = value.toLowerCase();
        }
        if (key === "defaultShareMethod") {
          value = value.toLowerCase();
        }
        result[key] = value;
      }
    });
  }

  return result;
};

export { getSharingCustomizations };
